import styled from 'styled-components';
import { DropdownInput } from '../../baseInputs/DropdownInput';
import { useScene } from '../../../../context/sceneContext';

export const AllowFullscreenVariableInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    {
      allowFullScreen: undefined,
    },
    'props'
  );

  return (
    <Row>
      <DropdownInput
        label="Allow Full Screen"
        value={data.allowFullScreen}
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
        onChange={(newValue) =>
          scene.updateSelectedElementsData({ allowFullScreen: newValue }, 'props', 'allowFullscreenVariableInput')
        }
        canBeCleared={false}
        isSearchable={false}
      />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
`;
